import { render, staticRenderFns } from "./UISwitchTheme.vue?vue&type=template&id=4777cae3&scoped=true"
import script from "./UISwitchTheme.vue?vue&type=script&lang=js"
export * from "./UISwitchTheme.vue?vue&type=script&lang=js"
import style0 from "./UISwitchTheme.vue?vue&type=style&index=0&id=4777cae3&prod&lang=scss&scoped=true"
import style1 from "./UISwitchTheme.vue?vue&type=style&index=1&id=4777cae3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4777cae3",
  null
  
)

export default component.exports